var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-tabs sm:border-0 sm:bg-white radius-3"},_vm._l((_vm.navigations),function(item,index){return _c('a',{key:`menu-tab-item-${index}`,class:[
      'tab-item',
      item.class,
      { active: item.routes.includes(_vm.activeTab) },
      { 'border-first': item.first },
      { 'border-last': item.last }
    ],on:{"click":function($event){return _vm.goto(item)}}},[_c('span',{staticClass:"mobile-icon"}),_c('span',{staticClass:"lg:hidden font-bold"},[_vm._v(_vm._s(item.labelDesktop))]),_c('span',{staticClass:"hidden lg:block font-bold"},[_vm._v(_vm._s(item.labelMobile))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }